import { theme } from "../../theme";

export const badgePreview = {
    wrapper: {
      background: theme.palette.grey["600"],
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    actions: {
      padding: "20px",
    },
    attendeeSelector: {
      padding: "20px",
      textAlign: "center",
    },
    previewCanvas: {
      background: "#fff",
      flexGrow: 1,
      padding: "20px",
    },
  } as const;
